module.exports = __webpack_public_path__ + "static/media/hourglass.ca6fcdbb.png";